import {TemplateList} from "~/libs/constants/TemplateList"

export const useTemplate = () => {
  type TemplateListKeys = keyof typeof TemplateList;
  const templateNameLowerCase:TemplateList | undefined = useRuntimeConfig().public.templateName ? String(useRuntimeConfig().public.templateName).toLowerCase() as TemplateList : undefined
  const templateNameUpperCase:TemplateListKeys | undefined = useRuntimeConfig().public.templateName ? String(useRuntimeConfig().public.templateName).toUpperCase() as TemplateListKeys : undefined

  const getComponentPathPrefix = (): string | undefined => {
    if (templateNameLowerCase) {
      return templateNameLowerCase.charAt(0).toUpperCase()
        + templateNameLowerCase.slice(1)
    }
  }

  const getTemplateListItem = (): TemplateList | undefined => {
    if (templateNameUpperCase && TemplateList[templateNameUpperCase]) {
      return TemplateList[templateNameUpperCase]
    }
  }

  return {
    templateNameLowerCase,
    templateNameUpperCase,
    getComponentPathPrefix,
    getTemplateListItem
  }

}
